import React, { Component } from 'react';
import './../../assets/css/App.css';
import $ from "jquery";

class DatePicker extends Component {

    state = {
        dateFieldValue: ""
    };

    constructor() {
        super();

    };

    componentDidMount () {
        //var fieldSelector = "#" + this.props.fieldId;
        this.fieldSelector = "#" + this.props.fieldId;
        $(this.fieldSelector).datepicker({
            showOtherMonths: true,
            selectOtherMonths: true,
            minDate: new Date(2012, 1-1, 1),
            maxDate: this.props.fieldType == "startDate" ? "0" : "+2w",
            dateFormat: "yy-mm-dd",
            onSelect : (value) => this.onDateFieldChange(value)
        });
    };

    componentWillUnmount() {
        //$(this.fieldSelector).datepicker('destroy');
    }
    onDateFieldChange = (value) => {
        this.props.onChange(value);
        this.setState({
            dateFieldValue : value
        })
    }

    onDateFieldClearIconClick = (e) => {
        console.log("Click on close");
        //e.preventDefault();
        //$(this.fieldSelector).val("");
        this.onDateFieldChange("")
        /*this.setState({
            dateFieldValue : ""
        })*/
    }

    render() {
        return (
            <div className="float-left">
                <label htmlFor={this.props.fieldId} href={"#" + this.props.fieldId}
                       className="search-container button-right btn-info" style={{cursor: 'pointer'}}>
                    <input type="search" id={this.props.fieldId} placeholder={this.props.placeHolderText}
                            value={this.state.dateFieldValue} />
                    {this.state.dateFieldValue == "" ? <i className="fa fa-calendar date-changes" aria-hidden="true" /> :
                        <i onClick={this.onDateFieldClearIconClick} className="fa date-changes fa-times-circle" aria-hidden="true" />
                    }

                </label>
            </div>
        );
    }
}

export default DatePicker;